import {
  ChakraBox,
  ChakraFlex,
  FAIconName,
  Icon,
  Text,
} from '@equip.health/ui';
import PatientNoteTreatmentAttributeLabel from './PatientNoteTreatmentAttributeLabel';
import { BaseTreatmentAttribute } from '~/lib/types/treatmentAttributes/treatmentAttributes';
import { getTreatmentAttributeEnum } from '~/lib/util/treatmentEpisodes.util';

type PatientNoteTreatmentAttributeProps = {
  title: string;
  latestAttributeWithNoteId?: BaseTreatmentAttribute;
  attributeAtNoteCreation?: BaseTreatmentAttribute;
};

const PatientNoteTreatmentAttribute = ({
  title,
  latestAttributeWithNoteId,
  attributeAtNoteCreation,
}: PatientNoteTreatmentAttributeProps) => {
  const attributeAtNoteCreationEnum = getTreatmentAttributeEnum(
    attributeAtNoteCreation,
  );
  const latestAttributeWithNoteIdEnum = getTreatmentAttributeEnum(
    latestAttributeWithNoteId,
  );

  return (
    <ChakraBox>
      <ChakraFlex alignItems="center" gap="10px">
        <Text
          color="neutral.secondary"
          id={`patient_note_treatment_attribute_title_${title}`}
          minWidth="110px"
          variant="caption"
        >
          {title}
        </Text>
        <ChakraFlex alignItems="center" gap="10px">
          <PatientNoteTreatmentAttributeLabel
            id={
              attributeAtNoteCreationEnum && 'id' in attributeAtNoteCreationEnum
                ? attributeAtNoteCreationEnum.id
                : undefined
            }
            label={attributeAtNoteCreationEnum?.label}
          />

          {latestAttributeWithNoteId ? (
            <Icon
              color="accent.blue"
              name={FAIconName.arrowRightRegular}
              aria-hidden={false}
              aria-label="Changed to"
            />
          ) : null}

          {latestAttributeWithNoteId ? (
            <PatientNoteTreatmentAttributeLabel
              id={
                'id' in latestAttributeWithNoteIdEnum
                  ? latestAttributeWithNoteIdEnum.id
                  : undefined
              }
              label={latestAttributeWithNoteIdEnum.label}
            />
          ) : null}
        </ChakraFlex>
      </ChakraFlex>
      {latestAttributeWithNoteId ? (
        <ChakraBox
          backgroundColor="secondary.5"
          borderRadius="12px"
          data-testid="patient-note-treatment-attribute-explanation"
          marginTop="6px"
          padding="12px"
        >
          <Text variant="caption">{latestAttributeWithNoteId.explanation}</Text>
        </ChakraBox>
      ) : null}
    </ChakraBox>
  );
};

export default PatientNoteTreatmentAttribute;
